export enum NewVendorSource {
  OFFLINE = "OFFLINE",
  ONLINE = "ONLINE",
  REFERRAL = "REFERRAL",
  PARTNER_APP = "PARTNER_APP",
  CUSTOMER_APP = "CUSTOMER_APP"
}
